import React from 'react'
import {Form, Select, Input, Button} from 'semantic-ui-react'
import * as noliAPI from '../utils/noliAPI'
import * as masks from '../utils/masks'

const SearchFuncionariosFilter = (props) => {

  const [filterType, setFilterType] = React.useState('todos')
  const [searchField, setSearchField] = React.useState('')

  React.useEffect(() => {
    if(props.reload){
      setFilterType('todos')
      setSearchField('')
    }
  }, [props.reload]);

  const changeFilterType = (e, {value}) => {
    setFilterType(value)
    setSearchField("")
  }

  const handleSubmit = () => {
    props.setLoading(true)
    if(filterType === "todos"){
      noliAPI.buscarFuncionariosPor().then(res => {
        props.setList(res.data.data)
        props.setLoading(false)
      })
    }else{
      const search = filterType === 'cpf' ? masks.unmaskCpf(searchField) : filterType === 'telefone' ? masks.unmaskTelefone(searchField) : searchField
      noliAPI.buscarFuncionariosPor(filterType, search).then(res => {
        if(res.status === 200){
          props.setList(res.data.data)
        }else props.setList([])
        props.setLoading(false)
      })
    }
  }

  const getMaskedValue = () => {
    if(filterType === 'telefone') return masks.maskTelefone(searchField)
    else if (filterType === 'cpf') return masks.maskCpf(searchField)
    else return searchField
  }

  return(
    <Form>
      <Form.Group>
        <Form.Field
          control={Select}
          options={options}
          placeholder="Selecione um filtro"
          value={filterType}
          onChange={changeFilterType}
          width="5"
        />
        <Form.Field
          control={Input}
          placeholder="Palavra-chave"
          value={getMaskedValue()}
          onChange={(e,{value}) => setSearchField(value)}
          maxLength={filterType==='telefone' ? 15 : 200}
          disabled={filterType === "todos"}
          width="8"
        />
        <Form.Field
          control={Button}
          content="BUSCAR"
          fluid
          color="blue"
          width="3"
          icon="search"
          type="submit"
          labelPosition="left"
          loading={props.loading}
          disabled={props.loading || (filterType !== "todos" && searchField === "")}
          onClick={handleSubmit}
        />
      </Form.Group>
    </Form>
  )
}

export default SearchFuncionariosFilter

const options = [
  {value: "todos", text: "Todos os funcionários"},
  {value: "nome", text: "por Nome"},
  {value: "telefone", text: "por Telefone"},
  {value: "cpf", text: "por CPF"},
  {value: "email", text: "por EMAIL"},
]
